"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCEL_RECEIPT_RESPONSE_EXAMPLE = exports.ISSUE_RECEIPT_RESPONSE_EXAMPLE = void 0;
const financial_common_response_1 = require("./financial-common.response");
exports.ISSUE_RECEIPT_RESPONSE_EXAMPLE = {
    receipt: financial_common_response_1.FIN_RECEIPT_RESPONSE_EXAMPLE,
    postingLog: financial_common_response_1.FIN_POSTING_EVENT_LOG_RESPONSE_EXAMPLE,
    notificationSent: false,
};
exports.CANCEL_RECEIPT_RESPONSE_EXAMPLE = {
    receipt: { ...financial_common_response_1.FIN_RECEIPT_RESPONSE_EXAMPLE, status: 'CANCELLED', reasonCode: 'DUPLICATE', cancelledAt: '2026-07-16T10:05:00.000Z' },
    notificationSent: false,
};
//# sourceMappingURL=financial-receipt.response.js.map